<script>
  import { isoLookup } from '../utils';
  import { mapTransform } from '../stores';

  export let labels = [];

  const positionLabel = label => {
    if (label.id === 'ua' || label.id === 'nl') {
      return `translate(${[label.cx, label.cy + label.offset + 15]})`
    }
    return `translate(${[label.cx, label.cy + label.offset]})`
  }
</script>

<style>
  .km-outer {
    stroke: #fff;
    fill: #3a3a3a;
    stroke-width: 1.5px;
    pointer-events: none;
  }

  .km-label {
    font-size: 12px;
    fill: #3a3a3a;
    pointer-events: none;
  }

  @media screen and (min-width: 800px) {
    .km-label {
      font-size: 13px;
    }
  }
</style>

<g transform={$mapTransform}>
  {#each labels as label, i}
    <text
      class="km-label km-outer"
      text-anchor="middle"
      transform={positionLabel(label)}>
      {i + 1}. {isoLookup[label.id]}
    </text>
    <text
      class="km-label"
      text-anchor="middle"
      transform={positionLabel(label)}>
      {i + 1}. {isoLookup[label.id]}
    </text>
  {/each}
</g>
